import { useNavigate } from 'react-router-dom';

import { MenuItem } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

type SessionsTableMoreOptionsViewSessionMenuItemProps = {
  sessionId: string;
  userEmail: string;
};

export const SessionsTableMoreOptionsViewSessionMenuItem = ({
  sessionId,
  userEmail,
}: SessionsTableMoreOptionsViewSessionMenuItemProps) => {
  const navigate = useNavigate();

  return (
    <MenuItem
      onClick={(evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        navigate(`/hde/participants/${userEmail}/sessions/${sessionId}`);
      }}
    >
      <Icon
        name={iconNames.listAlt}
        fill="var(--fgPrimary)"
        width="16px"
        height="16px"
      />{' '}
      Go to session
    </MenuItem>
  );
};
